import React from "react";
import { observer } from "mobx-react";
import { LandingInfo, RateInfo } from "../helpers/types";
import { Panel } from "../../ui";

// Guide + FAQ under the swap form on a coin page (/usdc-to-btc-lightning …).
// Copy comes from LandingPages on the server; minimums are the live rates.
const LandingGuide: React.FC<{ landing: LandingInfo; rates: RateInfo[] }> = observer(
  ({ landing, rates }) => (
    <Panel>
      <div className="flex flex-col gap-6 text-sm">
        <section>
          <h2 className="font-display text-xl font-semibold">How it works</h2>
          <ol className="mt-2 list-decimal space-y-1 pl-5 text-muted">
            {(landing.steps ?? []).map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>
        </section>

        <section>
          <h2 className="font-display text-xl font-semibold">Networks and minimums</h2>
          <ul className="mt-2 list-disc space-y-1 pl-5 text-muted">
            {(landing.networks ?? []).map(({ asset, network }) => {
              const rate = rates.find((r) => r.from === asset);
              return (
                <li key={asset}>
                  {landing.coin} on {network}
                  {rate?.online
                    ? `: minimum ${Number(rate.min_from)} ${landing.coin}`
                    : " (temporarily unavailable)"}
                </li>
              );
            })}
          </ul>
        </section>

        <section>
          <h2 className="font-display text-xl font-semibold">Questions</h2>
          <div className="mt-2 flex flex-col gap-3">
            {(landing.faq ?? []).map(({ q, a }) => (
              <div key={q}>
                <h3 className="font-semibold">{q}</h3>
                <p className="mt-1 text-muted">{a}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </Panel>
  )
);

export default LandingGuide;
